// extracted by mini-css-extract-plugin
module.exports = {"articles__schema":"_9e1425b4d3--articles__schema--bHxyK","articles-wrap":"_9e1425b4d3--articles-wrap--sW0ww","articles":"_9e1425b4d3--articles--v1r04"};